import MyBookingsIcon from "./MyBookingsIcon";
import DownloadIcons from "./DownloadIcons";
import DownloadInvoiceTextIcons from "./DownloadInvoiceTextIcons";
import RescheduleBookingsIcons from "./RescheduleBookingsIcons";
const BookingsIcons = {
  MyBookingsIcon,
  DownloadIcons,
  DownloadInvoiceTextIcons,
  RescheduleBookingsIcons,
};

export default BookingsIcons;
